import { render, staticRenderFns } from "./SessionEntriesDetails.vue?vue&type=template&id=b93c2f3e"
import script from "./SessionEntriesDetails.vue?vue&type=script&lang=js"
export * from "./SessionEntriesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports